export const review = {
  title: "レビュー",
  seeAll: "すべて見る",
  averageScore: "平均スコア",
  reviewCount: (args: { count: string | number }) =>
    `${args.count}件のレビュー`,
  countShort: (args: { count: string | number }) => `(${args.count}件)`,
  noReviews: "まだレビューがありません",
  highRating: "高評価",
  postTitle: "レビューを投稿",
  postTitleCall: "通話した女性にレビューを投稿してみましょう！",
  postTitleLive: "レビューを投稿してみましょう！",
  scoreLabel: "評価",
  scoreRequired: "評価を選択してください",
  comment: "コメント（任意）",
  commentMaxLength: (args: { max: string | number }) => `${args.max}文字以内`,
  submit: "投稿する",
  submitSuccess: "レビューを投稿しました",
  submitError: "投稿に失敗しました",
  alreadyReviewed: "すでにレビュー済みです",
  writeReview: "レビューを書く",
  requirementsTitle: "ビデオ通話レビュー投稿条件",
  requirementHasNotReviewed: "対象ユーザーにレビュー未投稿",
  requirementAlreadyReviewed: "すでにレビュー投稿済み",
  alreadyReviewedMessage: "この女性にはレビュー済みです",
  requirementCallDurationEnough: "通話/ライブ配信視聴が30秒以上",
  requirementCallDurationNotEnough: "通話/ライブ配信視聴が30秒未満",
  checkingRequirements: "条件を確認中...",
  fetchRequirementsError: "レビュー投稿条件の取得に失敗しました",
  // バッジ（レビューモーダル内の「バッジを贈る」）
  badgeSectionTitle: "バッジを贈る（任意）",
  badgeGrantError: "バッジの付与に失敗しました",
  // 獲得したバッジ（プロフィールの横スクロールセクション）
  badgeShowcaseTitle: "獲得したバッジ",
  badgeShowcaseTotal: (args: { count: string | number }) => `計${args.count}`,
  // ギフト（通話/ライブ後レビューモーダル内の横カルーセル）
  giftSectionTitle: "ギフトを贈る（任意）",
  /** バッジ ID → 表示名。ID は Jambo BadgeConstants と一致 */
  badgeNames: {
    mood_booster_badge: "盛り上げ上手",
    cute_smile_badge: "笑顔かわいい",
    cute_voice_badge: "声かわいい",
    face_reveal_badge: "顔出し",
    gap_moe_badge: "ギャップ萌え",
    lovense_high_sensitivity_badge: "Lovense反応◎",
    nice_style_badge: "Niceスタイル",
    plump_badge: "ムチムチ",
    s_girl_badge: "S女",
    m_girl_badge: "M女",
  },
  score: {
    "1": "最悪",
    "2": "悪い",
    "3": "普通",
    "4": "良い",
    "5": "最高",
  },
} as const;
